import { Component, OnInit } from '@angular/core';
import{ApiService} from '../../services/api.service';


@Component({
  selector: 'app-teachers',
  templateUrl: './teachers.page.html',
  styleUrls: ['./teachers.page.scss'],
})
export class TeachersPage implements OnInit {

  constructor(private api:ApiService) { }

  ngOnInit() {
  	this.getDataGuru();
  }

  dataGuru:any=[];
  getDataGuru()
  {
  	var keyApp=localStorage.getItem('keyApp');
  	this.api.data('guru?key_app='+keyApp,'get','').subscribe(data=>{
  		this.dataGuru=data;
  	})
  }

}
